import { Typography } from '@mui/material'
import {
  formatThreeDecimalsCell,
  formatDateCell,
} from '@/utils/cellFormat'
import { CustomColumnGridConfig } from '../types'

const columnsConfig: CustomColumnGridConfig[] = [
  {
    flex: 1,
    minWidth: 120,
    field: 'meterNumber',
    headerName: 'מספר מד',
    filter: { type: 'search' },
    filterable: true,
  },
  {
    flex: 1.2,
    minWidth: 130,
    field: 'timestamp',
    headerName: 'תאריך',
    hideable: true,
    disableAggregation: true,
    filter: { type: 'date' },
    filterable: true,
    format: formatDateCell,
    renderCell: params => (
      <Typography sx={{ fontFamily: 'Rubik, sans-serif', fontSize: '14px' }}>
        {params.formattedValue}
      </Typography>
    ),
  },
  {
    flex: 1,
    minWidth: 110,
    field: 'midnightCapacity',
    headerName: 'ק. חצות',
    filter: { type: 'aggregated' },
    filterable: true,
    format: formatThreeDecimalsCell,
  },
  // Hidden, not deleted: the daily rows never fill a back reading, so the column was always empty.
  // {
  //   flex: 1,
  //   minWidth: 110,
  //   field: 'backwardCapacity',
  //   headerName: 'ק. אחורה',
  //   filter: { type: 'aggregated' },
  //   filterable: true,
  // },
  {
    flex: 1,
    minWidth: 120,
    field: 'consumption',
    headerName: 'צריכה',
    filter: { type: 'aggregated' },
    filterable: true,
    format: formatThreeDecimalsCell,
  },
  {
    flex: 1,
    minWidth: 120,
    field: 'nightConsumption',
    headerName: 'צ.לילה',
    filter: { type: 'aggregated' },
    filterable: true,
    format: formatThreeDecimalsCell,
  },
  {
    flex: 1,
    minWidth: 120,
    field: 'consumptionChange',
    headerName: 'שינוי הצריכה',
    filter: { type: 'search' },
    filterable: true,
  },
]

export default columnsConfig
